import { MonitorOutlined } from '@ant-design/icons';
import { FLAG_ENABLE_APP_MONITOR, FLAG_ENABLE_DATA_LAKE_MONITOR } from '@mst-fe/shared/constants/zoe-user-flags';
import { ItemType, SubMenuType } from 'antd/lib/menu/interface';

import {
  APP_MONITOR_KEY,
  DATA_LAKE_MONITOR_KEY,
  FEEDS_MONITOR_KEY,
  MONITORING_APPS_KEY,
  MONITORING_APPS_KEY_PREFIX,
  SLA_MONITOR_KEY,
  STATUS_DASHBOARD_KEY,
} from '../../../side-nav/sidenav-constants';
import { UserInfoModel } from '../../user-info/models/user-info';

function getMonitoringAppsNavItems(isMidasPeer: boolean, isWbOrLsegUser: boolean, featureFlags: UserInfoModel['featureFlags']): ItemType[] {
  const items: ItemType[] = [];
  if (featureFlags.has(FLAG_ENABLE_DATA_LAKE_MONITOR) && (isWbOrLsegUser || isMidasPeer)) {
    items.push({
      label: 'Data Lake Monitor',
      icon: <MonitorOutlined />,
      key: `${MONITORING_APPS_KEY_PREFIX}${DATA_LAKE_MONITOR_KEY}`,
    });
  }
  // Don't show this page to users that have access to Zoe but are not part of lseg group or have wb permissions
  if (isWbOrLsegUser || isMidasPeer) {
    items.push({
      label: 'Feeds Monitor',
      icon: <MonitorOutlined />,
      key: `${MONITORING_APPS_KEY_PREFIX}${FEEDS_MONITOR_KEY}`,
    });
  }
  if (isMidasPeer) {
    items.push({
      label: 'SLA Monitor',
      icon: <MonitorOutlined />,
      key: `${MONITORING_APPS_KEY_PREFIX}${SLA_MONITOR_KEY}`,
    });
    items.push({
      label: 'Status Dashboard',
      icon: <MonitorOutlined />,
      key: `${MONITORING_APPS_KEY_PREFIX}${STATUS_DASHBOARD_KEY}`,
    });
  }
  if (featureFlags.has(FLAG_ENABLE_APP_MONITOR)) {
    items.push({
      label: 'App Monitor',
      icon: <MonitorOutlined />,
      key: `${MONITORING_APPS_KEY_PREFIX}${APP_MONITOR_KEY}`,
    });
  }

  return items;
}

export function getMonitoringAppsNav(
  isMidasPeer: boolean,
  isWbOrLsegUser: boolean,
  featureFlags: UserInfoModel['featureFlags']
): SubMenuType {
  return {
    key: MONITORING_APPS_KEY,
    label: 'Monitoring Apps',
    icon: <MonitorOutlined />,
    children: getMonitoringAppsNavItems(isMidasPeer, isWbOrLsegUser, featureFlags),
  };
}
